import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

type PreparingReportLoaderProps = {
  /** Cover the full viewport (initial page load). */
  fullScreen?: boolean;
  className?: string;
};

export function PreparingReportLoader({
  fullScreen = false,
  className,
}: PreparingReportLoaderProps) {
  const [showAlt, setShowAlt] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setShowAlt(true), 5000);
    return () => clearTimeout(id);
  }, []);

  const content = (
    <div
      className={cn("flex flex-col items-center gap-4", className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div
        className="cc-prepare-spinner size-11 rounded-full border-[2.5px] border-slate-200/90 border-t-navy"
        aria-hidden
      />
      <div className="relative h-5 overflow-hidden">
        <p
          className={cn(
            "text-sm font-medium tracking-wide text-slate-600 transition-all duration-500",
            showAlt ? "-translate-y-full opacity-0" : "translate-y-0 opacity-100",
          )}
        >
          Preparing your report
        </p>
        <p
          className={cn(
            "absolute inset-x-0 top-0 text-center text-sm font-medium tracking-wide text-slate-600 transition-all duration-500",
            showAlt ? "translate-y-0 opacity-100" : "translate-y-full opacity-0",
          )}
        >
          Just a bit longer
        </p>
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-surface">
        {content}
      </div>
    );
  }

  return content;
}
